import { MdFacebook } from 'react-icons/md';
import { ArrowRightIcon, BanIcon } from '@heroicons/react/outline';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { gql, useMutation } from '@apollo/client';
import { Account_AccountData_account } from '../../../types/graph/Account_AccountData';
import { GET_ACCOUNT } from '../../Account';
import { GET_ACCOUNT as GET_MARKETING_ACCOUNT } from '../../Listings/Details/Marketing';

interface Props {
  account: Account_AccountData_account;
}

const Facebook = ({ account }: Props) => {
  const [addIntegrations] = useMutation(ADD_INTEGRATIONS, {
    onCompleted: (data) => {
      console.log(data);
    },
    refetchQueries: [
      { query: GET_ACCOUNT, variables: { accountId: account.id } },
      { query: GET_MARKETING_ACCOUNT, variables: { accountId: account.id } },
    ],
  });

  const [removeIntegrations] = useMutation(REMOVE_INTEGRATIONS, {
    onCompleted: (data) => {
      console.log(data);
    },
    refetchQueries: [
      { query: GET_ACCOUNT, variables: { accountId: account.id } },
      { query: GET_MARKETING_ACCOUNT, variables: { accountId: account.id } },
    ],
  });

  const onResponse = (data: any) => {
    console.log('facebook: ', data);

    const payload = {
      accessToken: data.accessToken,
      userId: data.userID,
    };

    addIntegrations({
      variables: {
        input: {
          facebook: payload,
        },
      },
    });
  };

  const onDisconnect = () => {
    removeIntegrations({ variables: { integration: 'facebook' } });
  };

  return (
    <FacebookLogin
      appId="1587249021578134"
      initParams={{ version: 'v13.0' }}
      scope="pages_manage_posts,pages_read_engagement"
      onSuccess={onResponse}
      onFail={onResponse}
      // onProfileSuccess={onResponse}
      render={({ onClick }) => (
        <div
          className={`rounded-tl-lg rounded-tr-lg sm:rounded-tr-none relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-sky-500 hover:bg-gray-50`}
          onClick={
            account?.integrations?.facebook?.status === 'active'
              ? onDisconnect
              : onClick
          }
        >
          <div>
            <span
              className={`bg-blue-50 text-blue-600 rounded-lg inline-flex p-3 ring-4 ring-white`}
            >
              <MdFacebook className="h-7 w-7" aria-hidden="true" />
            </span>
          </div>
          <div className="mt-5">
            <h3 className="text-lg font-medium">
              <a href="#" className="focus:outline-none">
                {/* Extend touch target to entire panel */}
                <span className="absolute inset-0" aria-hidden="true" />
                Facebook
              </a>
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              {account?.integrations?.facebook?.status === 'active' ? (
                <span>
                  You are currently{' '}
                  <span className="text-green-600">connected</span> to your
                  Facebook account.
                </span>
              ) : (
                <span>
                  Connect to your Facebook account to easily create posts.
                </span>
              )}
            </p>
          </div>
          <span
            className="flex items-center space-x-2 pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
            aria-hidden="true"
          >
            {account?.integrations?.facebook?.status !== 'active' ? (
              <>
                <span className="text-xs">Connect</span>
                <ArrowRightIcon className="h-8 w-8 stroke-0 transform -rotate-45" />
              </>
            ) : (
              <div className="group-hover:text-red-400 flex items-center justify-center space-x-2">
                <span className="text-xs">Disconnect</span>
                <BanIcon className="h-6 w-6 stroke-0" />
              </div>
            )}
          </span>
        </div>
      )}
    />
  );
};

export default Facebook;

const ADD_INTEGRATIONS = gql`
  mutation Account_AddIntegrations($input: IntegrationsInput!) {
    addIntegrations(input: $input) {
      integrations {
        facebook {
          accessToken
          userId
          status
        }
      }
    }
  }
`;

const REMOVE_INTEGRATIONS = gql`
  mutation Account_RemoveIntegrations($integration: String!) {
    removeIntegrations(integration: $integration) {
      integrations {
        facebook {
          accessToken
          userId
          status
        }
      }
    }
  }
`;
